export function validateNumericValues(fields) {
    let errors = {}
    let hasErrors = false

    for (let i in fields) {
        if (fields[i].field.type === 'numeric' && fields[i].value.value &&
            (fields[i].value.value < fields[i].field.min_value || fields[i].value.value > fields[i].field.max_value)) {
            errors[i] = 'Field value must be between ' + fields[i].field.min_value + ' and ' + fields[i].field.max_value
            hasErrors = true
        }
    }

    return [errors, hasErrors]
}
